/**
 * Wiki Module
 * Main entry point for the wiki/knowledge base module
 */

import type { Module } from '../../index';
import { wikiRoutes } from './routes/config';

// Export components
export * from './components';

// Export services
export * from './services';

// Export pages
export { default as ArticleList } from './pages/ArticleList';
export { default as ArticleDetail } from './pages/ArticleDetail';
export { default as ArticleCreate } from './pages/ArticleCreate';
export { default as DepartmentDetail } from './pages/DepartmentDetail';

/**
 * Wiki Module Definition
 */
const wikiModule: Module = {
  name: 'ds-wiki',
  path: '/app/ds-wiki',
  routes: wikiRoutes,
  components: {
    // Export any shared components here
  },
  services: {
    // Export any shared services here
  },
};

export default wikiModule;
